// extracted by mini-css-extract-plugin
export default {"addressAction":"C8-z","loading":"D8-z"};